import { InfoOutlined } from "@mui/icons-material";
import { INFO_TEXTS } from "../constants";
import { Alert, FormHelperText } from "@mui/material";

export const TenantInfoText = ({ infoKey, alert = false, sx={} }) => {
  return alert ? (
    <Alert
      severity="infoAlert"
      variant="outlined"
      icon={<InfoOutlined fontSize="small" />}
      sx={sx}
    >
      {INFO_TEXTS[infoKey] || ""}
    </Alert>
  ) : (
    <FormHelperText
      sx={{
        display: "flex",
        gap: "3px",
      }}
    >
      <InfoOutlined
        fontSize="small"
        sx={{ height: "16px", width: "16px", mt: "2px" }}
      />
      {INFO_TEXTS[infoKey] || ""}
    </FormHelperText>
  );
};
